<footer class="footer">
  <div class="container">
    <div class="footer-content">
      <div class="row">
        <div class="col-lg-4">
          <div class="footer-section">
            <h5>Mitra Sanitär GmbH</h5>
            <p>Ihr Partner für moderne Sanitär- und Heizungstechnik. Tradition trifft Innovation.</p>
<!--
            <div class="social-links">
              <a href="#" class="social-link">
                <i class="fab fa-facebook"></i>
              </a>
              <a href="#" class="social-link">
                <i class="fab fa-instagram"></i>
              </a>
              <a href="#" class="social-link">
                <i class="fab fa-linkedin"></i>
              </a>
            </div>
-->
          </div>
        </div>
        
        <div class="col-lg-4" *ngIf="contactInfo">
          <div class="footer-section">
            <h5>Kontakt</h5>
            <div class="contact-item">
              <i class="fas fa-map-marker-alt"></i>
              <span>{{ contactInfo.address.street }}, {{ contactInfo.address.zip }} {{ contactInfo.address.city }}</span>
            </div>
            <div class="contact-item">
              <i class="fas fa-phone"></i>
              <span>{{ contactInfo.phone }}</span>
            </div>
            <div class="contact-item">
              <i class="fas fa-envelope"></i>
              <span>{{ contactInfo.email }}</span>
            </div>
          </div>
        </div>
        
        <div class="col-lg-4">
          <div class="footer-section">
            <h5>Quick Links</h5>
            <ul class="footer-links">
              <li><a routerLink="/services">Dienstleistungen</a></li>
              <li><a routerLink="/about/company">Über uns</a></li>
              <li><a routerLink="/contact">Kontakt</a></li>
              <li><a routerLink="/contact/career">Karriere</a></li>
              <li><a routerLink="/legal">Impressum</a></li>
            </ul>
          </div>
        </div>
      </div>
    </div>
    
    <div class="footer-bottom">
      <p>&copy; {{ currentYear }} Mitra Sanitär GmbH. Alle Rechte vorbehalten.</p>
    </div>
  </div>
</footer>